// This file is used for setting the webRootContext

const webRootContext = "/mychildrens";

export default webRootContext;